import { AccordionDetails, AccordionSummary, styled } from '@material-ui/core';

export const AccordionTitleContainer = styled(AccordionSummary)({
  minHeight: '0 !important',

  '&.Mui-expanded': {
    borderBottom: '1px solid #eef0f2'
  },

  '& .MuiAccordionSummary-content': {
    margin: '12px 0 !important'
  }
});

export const AccordionDetailsContainer = styled(AccordionDetails)(
  ({ theme }) => ({
    display: 'block',
    padding: theme.spacing(2)
  })
);
